import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const IntegrationSettings: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Integration Settings</Title>
      <p>Configure API settings, webhooks, and third-party service integrations.</p>
      <p>Manage payment gateways, email providers, and external services.</p>
    </Card>
  );
};

export default IntegrationSettings; 